var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popper',{staticClass:"keyboard-tips",attrs:{"trigger":"hover","append-to-body":true,"options":{
    placement: 'top',
    modifiers: { offset: { offset: '-95px,0px' } },
    preventOverflow: { padding: '0px' },
  }}},[_c('keyboard-popup',{staticClass:"popper"}),_vm._v(" "),_c('div',{staticClass:"-label wt2-color-link",attrs:{"slot":"reference"},slot:"reference"},[_vm._v("Keyboard Tips")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }